import axios from 'axios';
import authService from '@/utils/auth.js';

// Global axios interceptor to handle auth errors across all requests
// When tokens expire, redirect to login instead of trying to refresh
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Don't redirect if we're already on the public pages to avoid loops
    const currentPath = window.location.pathname;
    const isOnAuthPage = ['/login', '/register'].some(path =>
      currentPath === path || currentPath.endsWith(path)
    );
    const isOnPasswordResetPage = currentPath === '/reset_user_password' || currentPath.startsWith('/reset_user_password/');
    
    // Handle 401 errors (token expired/invalid) - redirect to login
    if (error.response?.status === 401 && !isOnAuthPage && !isOnPasswordResetPage) {
      window.location.href = '/login?error=session_expired';
      return Promise.reject(error);
    }

    // Handle 403 errors (forbidden) - redirect to login  
    if (error.response?.status === 403 && !isOnAuthPage && !isOnPasswordResetPage) {
      window.location.href = '/login?error=access_forbidden';
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default authService;
